import { render } from "./Icons.vue?vue&type=template&id=6d6e4fe9&scoped=true"
import script from "./Icons.vue?vue&type=script&lang=js"
export * from "./Icons.vue?vue&type=script&lang=js"

import "./Icons.vue?vue&type=style&index=0&id=6d6e4fe9&lang=scss&scoped=true"

import exportComponent from "/Users/wojciechkasprzak/WWW/ilona-michal-2021/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6e4fe9"]])

export default __exports__